export const useDataLayer = () => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return {
      push: () => void 0,
    }
  }

  return window.dataLayer
}
